import { render, staticRenderFns } from "./detective-results.vue?vue&type=template&id=444a1426&"
import script from "./detective-results.vue?vue&type=script&lang=js&"
export * from "./detective-results.vue?vue&type=script&lang=js&"
import style0 from "./detective-results.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../usr/local/lib/node_modules/@vue/cli-service-global/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports